import { render } from "./TradeConfirmed.vue?vue&type=template&id=352000b9&scoped=true"
import script from "./TradeConfirmed.vue?vue&type=script&lang=js"
export * from "./TradeConfirmed.vue?vue&type=script&lang=js"

import "./TradeConfirmed.vue?vue&type=style&index=0&id=352000b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352000b9"]])

export default __exports__